import axios from 'axios'
import urls from '@src/@core/auth/jwt/urls'

const invoiceApiV = axios.create({
  baseURL: urls.url + '/invoice',
  // timeout: 10000
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json'
  }
})

export const invoiceApi = {
  // Batch Management
  getBatches: (params = {}) => invoiceApiV.get('/invoice-batches/', { params }),
  getBatchDetail: (batchId) => invoiceApiV.get(`/invoice-batches/${batchId}/`),
  createBatch: (batchData) => invoiceApiV.post('/invoice-batches/preview/', batchData),
  saveBatch: (batchData) => invoiceApiV.post('/invoice-batches/save_batch/', batchData),
  saveBatchMigrate: (batchData) => invoiceApiV.post(batchData.settlement_flow ? '/invoice-batches/save_and_approve/' : '/invoice-batches/save_and_migrate/', batchData),
  updateAndMigrateBatch: (batch) => (batch.settlement_flow ? invoiceApiV.post(`/invoice-batches/${batch.id}/approve/`) : invoiceApiV.post('/invoice-batches/update_and_migrate/', { batch_id: batch.id || batch })),
  confirmBatch: (batchId, selectedContracts = null) => invoiceApiV.post(`/invoice-batches/${batchId}/confirm/`, { selected_contracts: selectedContracts }),
  deleteBatch: (batchId) => invoiceApiV.delete(`/invoice-batches/${batchId}/`),

  // Draft Invoices (borradores generados)
  getDrafts: () => invoiceApiV.get('/invoice-drafts/'),
  getBatchDrafts: (batchId) => invoiceApiV.get(`/invoice-batches/${batchId}/drafts/`),
  sendToContifico: (draftId) => invoiceApiV.post(`/invoice-drafts/${draftId}/send_to_contifico/`),


  getHistory: () => invoiceApiV.get('/invoices/') // TODO: Implementar endpoint histórico
}
